import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { Profile } from '@src/types/common/Profile'
import { RoleId } from '@src/types/common/RoleId'

interface Options {
  id: number,
  serialId: number,
  projectInternalId: number,
  street: string,
  suburb: string,
  dueDate: string,
  supervisor: Profile,
}

export const apiSifUpdate = (options: Options) => {
  const { 
    id,
    serialId,
    projectInternalId,
    street,
    suburb,
    dueDate,
    supervisor,
  } = options
  const data = {
    id,
    projectInternalId,
    street,
    suburb,
    dueDate,
    supervisor: {
      serialId: supervisor.serialId
    },
  }
  const axOptions = {
    method: 'PUT',
    url: `${BASE_API_URL}/v2/sif/${id}`,
    data,
    params: {
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(axOptions)
}